<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1">
        <div v-if="detailData != null">
          <v-stepper non-linear flat v-model="stepper_value">
            <v-stepper-header>
              <v-stepper-step step="1" editable @click="getDataFromApi">
                Laporan Awal Insiden
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                step="2"
                editable
                @click="getInspectionReportDetail"
                :rules="[validateInspectionRules]"
              >
                Pemeriksaan & Pengkajian Masalah
                <small
                  v-if="
                    detailData == null || detailData.inspection_report == null
                  "
                  >Data belum tersedia</small
                >
                <small v-else>
                  <span v-if="detailData.inspection_report.status == 0">
                    Data belum disubmit</span
                  >
                  <span v-if="detailData.inspection_report.status == 2">
                    Dokumen Canceled</span
                  >
                </small>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                step="3"
                editable
                @click="getRootProblemReportDetail"
                :rules="[validateRootProblemRules]"
              >
                Pencarian Akar Masalah
                <small
                  v-if="
                    detailData == null || detailData.root_problem_report == null
                  "
                  >Data belum tersedia</small
                >
                <small v-else>
                  <span
                    v-if="
                      detailData.root_problem_report.status != 1 &&
                      detailData.root_problem_report.status != 2 &&
                      detailData.root_problem_report.status != 5
                    "
                  >
                    Data belum lengkap</span
                  >
                  <span
                    style="color: orange"
                    v-if="detailData.root_problem_report.status == 1"
                  >
                    Waiting Approval</span
                  >
                  <span
                    style="color: orange"
                    v-if="detailData.root_problem_report.status == 2"
                  >
                    Butuh Verifikasi</span
                  >
                </small>
              </v-stepper-step>
              <v-divider style="border: none"></v-divider>
              <div style="text-align: right">
                <v-btn
                  type="button"
                  rounded
                  elevation="0"
                  class="font-weight-bold ma-2"
                  @click.prevent="closeDetailReport"
                  small
                  text
                >
                  <v-icon small>mdi-chevron-left</v-icon>
                  Kembali
                </v-btn>
              </div>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1" style="padding: 10px 3px 0 3px">
                <div class="custom-scroll-wrapper">
                  <v-row no-gutters class="sticky-header">
                    <v-col cols="12">
                      <v-card
                        elevation="0"
                        style="
                          border-bottom: 2px solid rgba(0, 0, 0, 0.1);
                          display: flex;
                          justify-content: space-between;
                        "
                      >
                        <v-card-title style="margin: 0; padding: 3px 0 2px 0">
                          <p
                            class="text-h6 font-weight-bold text-left text-uppercase"
                            style="margin: 0; position: relative; top: -10px"
                          >
                            Detail Laporan Awal Insiden
                            <v-tooltip bottom color="grey">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  x-small
                                  text
                                  icon
                                  color="grey darken-2"
                                  @click="getDataFromApi"
                                  style="position: relative; top: -3px"
                                >
                                  <v-icon small>mdi-refresh</v-icon>
                                </v-btn>
                              </template>
                              <span>refresh page</span>
                            </v-tooltip>
                          </p>
                          <p
                            v-if="detailData"
                            style="
                              position: absolute;
                              bottom: -25px;
                              left: -2px;
                              font-weight: bold;
                              padding-left: 3px;
                              font-size: 14px;
                            "
                          >
                            {{ detailData.document_no }}
                          </p>
                        </v-card-title>
                        <v-card-actions class="actionButton">
                          <div
                            style="
                              position: absolute;
                              bottom: 2px;
                              right: 0;
                              border: 1px solid black;
                            "
                          >
                            <p
                              v-if="detailData"
                              :style="`background-color: ${initialStatusColor(
                                detailData.status
                              )};
                color: white;
                font-weight: bold;
                width: 180px;
                text-align: center;
                margin:0`"
                            >
                              {{ detailData.status.name }}
                            </p>
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="0" v-if="detailData != null">
                        <v-card-text style="padding: 5px 0; margin: 0">
                          <p
                            style="
                              position: absolute;
                              top: -2px;
                              left: -2px;
                              font-weight: bold;
                              padding: 0 0 0 4px;
                              font-size: 12px;
                            "
                          >
                            Tgl. Buat: {{ detailData.created_at }} |
                            {{ detailData.created_by_name }}
                          </p>
                        </v-card-text>
                        <v-card-actions
                          v-if="
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminK3 ||
                                id == appLevel.picK3 ||
                                id == appLevel.administrator
                            ) != undefined
                          "
                        >
                          <div
                            v-if="!isEdit"
                            style="
                              position: absolute;
                              top: 0;
                              right: 0px;
                              padding-left: 2px;
                            "
                          >
                            <div
                              v-if="
                                detailData.status.id == 0 ||
                                detailData.status.id == 1
                              "
                            >
                              <v-btn
                                v-if="detailData.status.id == 0"
                                style="font-weight: bold"
                                x-small
                                text
                                outlined
                                color="primary"
                                @click.prevent="enableEdit"
                              >
                                <v-icon
                                  x-small
                                  color="primary"
                                  style="position: relative; top: 1px"
                                >
                                  mdi-pencil
                                </v-icon>
                                Edit Header
                              </v-btn>
                              <v-btn
                                v-if="detailData.status.id == 0"
                                style="font-weight: bold; margin-left: 5px"
                                x-small
                                text
                                outlined
                                color="success"
                                @click="submitReportDocument"
                              >
                                SUBMIT
                              </v-btn>
                              <v-btn
                                style="font-weight: bold; margin-left: 5px"
                                x-small
                                text
                                outlined
                                color="red"
                                @click="cancelReportDocument"
                              >
                                CANCEL
                              </v-btn>
                            </div>
                            <div v-if="detailData.status.id == 2">
                              <v-btn
                                style="font-weight: bold; margin-left: 5px"
                                x-small
                                text
                                outlined
                                color="primary"
                                @click="setDraftReport"
                              >
                                SET DRAFT
                              </v-btn>
                            </div>
                          </div>

                          <div
                            v-else
                            style="
                              position: absolute;
                              top: 0;
                              right: 0px;
                              padding-left: 2px;
                            "
                          >
                            <v-btn
                              style="font-weight: bold"
                              x-small
                              text
                              outlined
                              color="primary"
                              type="button"
                              @click="saveForm"
                            >
                              <v-icon
                                x-small
                                color="primary"
                                style="position: relative; top: 1px"
                              >
                                mdi-content-save-edit-outline
                              </v-icon>
                              Save
                            </v-btn>
                            <v-btn
                              style="font-weight: bold; margin-left: 10px"
                              x-small
                              text
                              outlined
                              color="red"
                              @click="enableEdit"
                            >
                              <v-icon
                                x-small
                                color="red"
                                style="position: relative; top: 1px"
                              >
                                mdi-cancel
                              </v-icon>
                              Cancel
                            </v-btn>
                          </div>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-card elevation="0" v-if="detailData != null">
                        <v-form
                          ref="initialReportFormRef"
                          :readonly="!isEdit"
                          @submit.prevent="saveForm"
                          style="margin-top: 10px"
                        >
                          <div>
                            <v-row>
                              <v-col
                                v-if="!isEdit"
                                cols="12"
                                md="3"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  No. Dokumen
                                </p>
                                <v-text-field
                                  v-model="detailData.document_no"
                                  dense
                                  readonly
                                  style="height: 15px"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                md="4"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Perusahaan
                                </p>
                                <v-text-field
                                  v-if="!isEdit"
                                  v-model="detailData.company.name"
                                  dense
                                  :clearable="isEdit"
                                  style="height: 15px"
                                />
                                <v-autocomplete
                                  v-else
                                  v-model="detailData.company"
                                  :items="dropdown.company"
                                  :rules="rules.companyRules"
                                  outlined
                                  :clearable="isEdit"
                                  item-text="name"
                                  item-value="id"
                                  return-object
                                  dense
                                  style="height: 15px"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                :md="!isEdit ? 2 : 3"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Tgl. Kejadian
                                </p>
                                <v-text-field
                                  v-model="detailData.incident_date"
                                  dense
                                  :outlined="isEdit"
                                  :clearable="isEdit"
                                  style="height: 15px"
                                  type="date"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                md="2"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Waktu. Kejadian
                                </p>
                                <v-text-field
                                  v-model="detailData.incident_time"
                                  dense
                                  :outlined="isEdit"
                                  :clearable="isEdit"
                                  style="height: 15px"
                                  type="time"
                                />
                              </v-col>

                              <v-col
                                cols="12"
                                md="3"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Lokasi Kejadian
                                </p>
                                <v-text-field
                                  v-if="!isEdit"
                                  v-model="detailData.incident_location.name"
                                  dense
                                  :clearable="isEdit"
                                  style="height: 15px"
                                />
                                <v-autocomplete
                                  v-else
                                  v-model="detailData.incident_location"
                                  :items="dropdown.area"
                                  :rules="rules.locationRules"
                                  outlined
                                  :clearable="isEdit"
                                  item-text="name"
                                  item-value="id"
                                  return-object
                                  dense
                                  style="height: 15px"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                v-if="!isEdit"
                                cols="12"
                                md="2"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Jml. Korban
                                </p>
                                <v-text-field
                                  :value="detailData.total_victim"
                                  dense
                                  readonly
                                  style="height: 15px"
                                />
                              </v-col>
                              <v-col
                                v-if="!isEdit"
                                cols="12"
                                md="3"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Tgl. Dilaporkan
                                </p>
                                <v-text-field
                                  :value="
                                    detailData.reported_date
                                      | moment('YYYY-MM-DD')
                                  "
                                  dense
                                  readonly
                                  style="height: 15px"
                                  type="date"
                                />
                              </v-col>
                              <v-col
                                v-if="!isEdit"
                                cols="12"
                                md="3"
                                class="d-flex flex-column"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Dilaporkan Oleh
                                </p>
                                <v-text-field
                                  :value="detailData.created_by_name"
                                  dense
                                  readonly
                                  style="height: 15px"
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                v-if="isEdit"
                                class="mt-2"
                              ></v-col>
                              <!-- <v-col cols="11" class="d-flex flex-column">
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Penyebab
                                </p>
                                <v-text-field
                                  v-model="detailData.cause"
                                  dense
                                  :outlined="isEdit"
                                  :clearable="isEdit"
                                  style="height: 15px"
                                />
                              </v-col> -->
                              <v-col
                                cols="12"
                                v-if="isEdit"
                                class="mt-2"
                              ></v-col>
                              <v-col cols="11" class="d-flex flex-column">
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Kronologi Kejadian
                                </p>
                                <v-textarea
                                  v-model="detailData.chronology"
                                  :rows="isEdit ? 5 : 3"
                                  :auto-grow="true"
                                  :outlined="isEdit"
                                  :clearable="isEdit"
                                />
                              </v-col>

                              <v-col
                                v-if="detailData.status.id == 2"
                                cols="11"
                                class="d-flex flex-column"
                                style="position: relative; top: -25px"
                              >
                                <p
                                  class="text-left"
                                  style="
                                    margin: 0;
                                    font-size: 12px;
                                    font-weight: bold;
                                    color: rgba(0, 0, 0, 0.5);
                                  "
                                >
                                  Alasan Cancel
                                </p>
                                <v-text-field
                                  v-model="detailData.cancel_note"
                                  rows="5"
                                  :auto-grow="true"
                                />
                              </v-col>
                            </v-row>
                          </div>
                        </v-form>
                        <v-card v-if="!isEdit" class="mt-5 mb-12">
                          <v-tabs
                            v-model="tab"
                            background-color="#ccdbdc"
                            slider-color="primary"
                          >
                            <v-tab v-for="item in tabItems" :key="item.tab">
                              {{ item.tab }}
                            </v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="tab">
                            <v-tab-item
                              v-for="item in tabItems"
                              :key="item.tab"
                              style="padding: 10px"
                            >
                              <div style="padding: 0">
                                <div
                                  v-if="item.tab == 'Data Saksi & Korban'"
                                  style="padding-top: 10px"
                                >
                                  <div class="position-relative z-0">
                                    <v-btn
                                      v-if="
                                        !isEdit &&
                                        detailData.status.id == 0 &&
                                        getUserProfile.level.find(
                                          ({ id }) =>
                                            id == appLevel.adminK3 ||
                                            id == appLevel.picK3 ||
                                            id == appLevel.administrator
                                        ) != undefined
                                      "
                                      color="blue darken-1"
                                      type="button"
                                      small
                                      outlined
                                      class="white--text"
                                      @click="addNewPersonInvolve"
                                    >
                                      Tambah Data
                                    </v-btn>
                                  </div>
                                  <v-card elevation="1" class="mt-5">
                                    <div
                                      class="d-flex"
                                      style="
                                        position: absolute;
                                        top: -15px;
                                        left: 2px;
                                        z-index: 3;
                                      "
                                    >
                                      <p
                                        class="text-left"
                                        style="
                                          margin: 0;
                                          font-size: 12px;
                                          font-weight: bold;
                                          color: rgba(0, 0, 0, 0.5);
                                        "
                                      >
                                        Korban : {{ detailData.total_victim }}
                                      </p>
                                      <p
                                        class="text-left ml-1"
                                        style="
                                          margin: 0;
                                          font-size: 12px;
                                          font-weight: bold;
                                          color: rgba(0, 0, 0, 0.5);
                                        "
                                      >
                                        Saksi :
                                        {{
                                          detailData.person_involve.length -
                                          detailData.total_victim
                                        }}
                                      </p>
                                    </div>
                                    <v-data-table
                                      mobile-breakpoint="0"
                                      fixed-header
                                      :headers="objPersonHeaders"
                                      style="cursor: pointer"
                                      :items="detailData.person_involve"
                                      :loading="loading"
                                      @click:row="personInvovleRowClick"
                                      :items-per-page="10"
                                    >
                                      <template v-slot:[`item.name`]="{ item }">
                                        <div
                                          style="
                                            width: 120px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.name }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.birth_date`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 70px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.birth_date }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.gender`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 70px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{
                                            item.gender == 1
                                              ? 'Laki-laki'
                                              : item.gender == 2
                                              ? 'Perempuan'
                                              : '-'
                                          }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.no_identitas`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 70px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.no_identitas }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.person_type`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 70px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{
                                            item.person_type == 1
                                              ? 'Karyawan'
                                              : item.person_type == 2
                                              ? 'Non Karyawan'
                                              : '-'
                                          }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.engagement_type`]="{
                                          item
                                        }"
                                      >
                                        <div
                                          style="
                                            width: 90px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{
                                            item.engagement_type == 1
                                              ? 'Korban'
                                              : item.engagement_type == 2
                                              ? 'Saksi'
                                              : '-'
                                          }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.employee_leader_name`]="{
                                          item
                                        }"
                                      >
                                        <div
                                          style="
                                            width: 140px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.employee_leader_name }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.injured_category`]="{
                                          item
                                        }"
                                      >
                                        <div
                                          style="
                                            width: 80px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{
                                            item.injured_category != null
                                              ? item.injured_category.name
                                              : '-'
                                          }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.body_part`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 210px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                            overflow: auto;
                                          "
                                        >
                                          <v-chip
                                            v-for="(
                                              obj, idx
                                            ) in item.injured_body_part_id"
                                            :key="idx"
                                            label
                                            outlined
                                            small
                                            style="
                                              position: relative;
                                              margin-right: 5px;
                                              padding: 0 3px;
                                              cursor: pointer;
                                              border: 1px solid
                                                rgba(0, 0, 0, 0.5);
                                            "
                                          >
                                            {{ getBodyPartName(obj) }}
                                          </v-chip>
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.machine_used`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 80px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.machine_used }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.amount_loss`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 60px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.amount_loss }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.rehabilitation_days`]="{
                                          item
                                        }"
                                      >
                                        <div
                                          style="
                                            width: 60px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.rehabilitation_days }}
                                          {{
                                            item.engagement_type == 1
                                              ? ' Hari'
                                              : ''
                                          }}
                                        </div>
                                      </template>

                                      <template
                                        v-slot:[`item.company_name`]="{ item }"
                                      >
                                        <div
                                          style="
                                            min-width: 180px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.company_name }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.department_name`]="{
                                          item
                                        }"
                                      >
                                        <div
                                          style="
                                            min-width: 180px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                          "
                                        >
                                          {{ item.department_name }}
                                        </div>
                                      </template>
                                      <template
                                        v-slot:[`item.action`]="{ item }"
                                      >
                                        <div
                                          style="
                                            width: 15px;
                                            font-size: 12px;
                                            padding: 0;
                                            display: flex;
                                            flex-direction: row;
                                            justify-content: space-between;
                                          "
                                        >
                                          <v-tooltip right>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                color="error"
                                                @click.stop="
                                                  deletePersonInvolve(item)
                                                "
                                              >
                                                mdi-delete
                                              </v-icon>
                                            </template>
                                            <span>Delete</span>
                                          </v-tooltip>
                                        </div>
                                      </template>
                                    </v-data-table>
                                  </v-card>
                                </div>
                              </div>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-card>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2" style="padding: 10px 3px 0 3px">
                <InspectionReportDetail
                  v-if="detailData != null"
                  ref="inspectionReportRef"
                  @loadPage="getDataFromApi"
                  @handlePersonFromChild="handlePersonFromChild"
                  :initialreport="detailData"
                  :appLevel="appLevel"
                  :getdropdown="dropdown"
                />
              </v-stepper-content>

              <v-stepper-content step="3" style="padding: 10px 3px 0 3px">
                <RootProblemReportDetail
                  v-if="detailData != null"
                  ref="rootProblemReportRef"
                  @loadPage="getDataFromApi"
                  :initialreport="detailData"
                  :appLevel="appLevel"
                  :getdropdown="dropdown"
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <PersonInvolveForm
            ref="personInvolveRef"
            @savePersonInvolve="savePersonInvolve"
            :personInvolveUpdateForm="personInvolveUpdateForm"
            :dropdownData="dropdown"
            :initialreport="detailData"
          />
        </div>
        <v-card
          v-else
          flat
          height="90vh"
          style="display: flex; justify-content: center; align-items: center"
        >
          <v-toolbar-title class="overline"> Data Not Found</v-toolbar-title>
        </v-card>
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import buildType from '../../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'incidentreportdetail',
  components: {
    PersonInvolveForm: () => import('./components/PersonInvolveForm.vue'),
    InspectionReportDetail: () => import('./inspectionreport/Detail.vue'),
    RootProblemReportDetail: () => import('./rootproblemreport/Detail.vue')
  },
  data() {
    return {
      stepper_value: 1,
      config: require('../../../../services/config.json')[env],
      build: process.env.VUE_APP_BUILD_TYPE,
      oAuthApi: buildType.apiURL('oauth'),
      dssApi: buildType.apiURL('dss'),
      eSanqua: buildType.apiURL('esanqua'),
      uploadApi: buildType.apiURL('upload2'),
      hrsApi: buildType.apiURL('hrs'),
      permission: null,
      appLevel: null,
      userLevel: null,
      detailData: null,
      isEdit: false,
      isLoadingPage: true,
      loading: false,
      isDisableCompanyDropdown: false,
      skeleton_loading: true,

      rules: {
        nameRules: [],
        locationRules: []
      },
      dropdown: {
        company: [],
        body_part: [],
        area: []
      },

      // commentDialog: false,
      // commentNote: null,
      tab: null,
      personInvolveUpdateForm: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  async mounted() {
    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.getDataMenu()
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    tabItems() {
      const arr = [{ tab: 'Data Saksi & Korban', content: '' }]
      return arr
    },
    objPersonHeaders() {
      const arrHeaders = [
        {
          text: 'Nama',
          value: 'name'
        },
        {
          text: 'Tgl. Lahir',
          value: 'birth_date'
        },
        {
          text: 'Jenis Kelamin',
          value: 'gender'
        },
        {
          text: 'No. KTP',
          value: 'no_identitas'
        },
        {
          text: 'Status',
          value: 'person_type'
        },
        {
          text: 'Keterlibatan',
          value: 'engagement_type'
        },
        {
          text: 'Kategori',
          value: 'injured_category'
        },
        {
          text: 'Bagian Cidera',
          value: 'body_part'
        },
        {
          text: 'Mesin Digunakan',
          value: 'machine_used'
        },
        {
          text: 'Kerugian',
          value: 'amount_loss'
        },
        {
          text: 'Rehab',
          value: 'rehabilitation_days'
        },
        {
          text: 'Perusahaan',
          value: 'company_name'
        },
        {
          text: 'Department',
          value: 'department_name'
        },
        {
          text: 'Atasan',
          value: 'employee_leader_name'
        }
      ]
      if (!this.isEdit) {
        arrHeaders.unshift({
          text: '',
          value: 'action'
        })
      }
      return arrHeaders
    }
  },
  watch: {},
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations([
      // /*'setOvertimePageQuery'*/
    ]),

    showMsgDialog2(pModalType, pStatusMsg, pBtnCancel, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: 'textarea',
            inputLabel:
              'Tolong isi keterangan pada kolom dibawah sebelum submit',
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn || 'OK',
            cancelButtonText: noBtn || 'NO'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async initDropdown() {
      this.getDropdownCompany()
      this.getDropdownBodyPart()
      this.getDropdownArea()
    },

    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2] + '/' + split[3]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            // console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    async initDataForLayout() {
      setTimeout(async () => {
        this.initDropdown()
        await this.getDataFromApi()
      }, 200)
    },
    async getDataFromApi() {
      this.loading = true
      const url = `${this.dssApi}initialreport/detail/${this.$route.params.id}`
      console.log('incidentreport.getDataFromApi >>>', url)
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            this.loading = false
            this.detailData = res.data.data
            this.detailData.victim = this.countVictims(
              res.data.data.person_involve
            )

            if (res.data.data.status.id == 1) {
              // this.authorityCheck(res.data.data);
            }
            setTimeout(() => {
              console.log('detailData >>>', this.detailData)
              // this.getIncidentReportData()
              // this.getLeadingReportData()
            }, 300)
          } else {
            this.loading = false
            // this.showMsgDialog('error', res.data.status_msg, false)
          }
          return null
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          return null
        })
    },
    // authorityCheck(item) {
    //   if (item.approval_matrix !== null) {
    //     const matrixId = item.approval_matrix[0].document_id;
    //     axios
    //       .get(
    //         `${this.oAuthApi}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=23`
    //       )
    //       .then((res) => {
    //         console.log('AuthorityCheck>>>', res);

    //         if (res.data.status_code === '00') {
    //           if (res.data.is_allow_approve !== 0) {
    //             this.isAllowApprove = true;
    //           } else {
    //             this.isAllowApprove = false;
    //           }
    //         } else {
    //           this.isAllowApprove = false;
    //         }
    //       })
    //       .catch((err) => {
    //         this.showMsgDialog(
    //           'error',
    //           err
    //             ? 'Cek Otoritas error, Silahkan info ke Admin'
    //             : 'Cek Otoritas error, Silahkan info ke Admin',
    //           false
    //         );
    //       });
    //   }
    // },
    // async fetchMatrix() {
    //   this.loading = true;
    //   const form = {
    //     id: this.$route.params.id
    //     // approval_matrix_id: this.detailData.approval_matrix[0].document_id
    //   };
    //   await axios
    //     .post(`${this.dssApi}initialreport/fetch_matrix`, form)
    //     .then(async (res) => {
    //       if (res.data.status_code == '00') {
    //         if (res.data.approval_matrix_result.status_code == '00') {
    //           this.getDataFromApi();
    //         } else {
    //           this.showMsgDialog(
    //             'warning',
    //             res.data.approval_matrix_result.status_msg,
    //             false
    //           );
    //         }
    //       } else {
    //         this.showMsgDialog('error', res.data.status_msg, false);
    //       }
    //       this.loading = false;
    //       this.showMsgDialog(
    //         res.data.status_code == '00' ? 'success' : 'warning',
    //         res.data.status_msg,
    //         false
    //       );
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.loading = false;
    //     });
    // },
    closeDetailReport() {
      this.detailData = null
      this.isEdit = false
      setTimeout(() => {
        this.$router.push('/dss/k3/incidentreport')
      }, 300)
    },

    async getDropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownBodyPart() {
      const url = `${this.dssApi}master/universal/bodypart/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.body_part = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownArea() {
      const url = `${this.dssApi}master/universal/area/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.area = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    enableEdit() {
      this.isEdit = !this.isEdit

      if (!this.isEdit) {
        this.dropdown.company = []
        // this.detailData.pic = null
        // this.searchEmployee = null
        this.getDataFromApi()
      } else {
        this.getDropdownCompany()
        // this.querySelectionEmployee(this.detailData.pic_name)
      }
    },

    saveForm() {
      this.rules.nameRules = [(v) => !!v || 'Name is required']
      this.rules.locationRules = [(v) => !!v || 'Location is required']

      const self = this
      setTimeout(function () {
        if (self.$refs.initialReportFormRef.validate()) {
          const form = {
            act: 'update',
            id: self.detailData.id,
            incident_date_time: self.detailData.incident_date + ' ' + self.detailData.incident_time + ':00',
            // company_id: self.detailData.company.id,
            // company_name: self.detailData.company.name,
            reported_date: self.detailData.reported_date,
            chronology: self.detailData.chronology,
            incident_location_id:
              self.detailData.incident_location != null
                ? self.detailData.incident_location.id
                : null,
            incident_location_name:
              self.detailData.incident_location != null
                ? self.detailData.incident_location.name
                : null,
            cause: self.detailData.cause
          }
          if (self.detailData.company != null) {
            Object.assign(form, {
              company_id: self.detailData.company.id,
              company_name: self.detailData.company.name
            })
          }
          console.log('form>>>', form)

          self.submitForm(form)
        }
      })
    },
    async submitForm(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}initialreport/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.enableEdit()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    submitReportDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
          }
          axios
            .post(`${this.dssApi}initialreport/submit`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetchMatrix()
                // } else {
                this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    // confirmReportDocument() {
    //   this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
    //     async (res) => {
    //       if (res.isConfirmed) {
    //         this.loading = true
    //         const form = {
    //           document_id: this.$route.params.id,
    //           note: res.value
    //         }
    //         axios
    //           .post(`${this.dssApi}performancereport/approve`, form)
    //           .then(async (res) => {
    //             this.loading = false
    //             if (res.data.status_code == '00') {
    //               this.showMsgDialog('success', res.data.status_msg, false)
    //               this.getDataFromApi()
    //               // if (this.detailData.approval_matrix !== null) {
    //               //   await this.fetch()
    //               //   console.log('fetch done')
    //               // } else {
    //               //   this.getDataFromApi()
    //               // }
    //             } else {
    //               this.showMsgDialog('warning', res.data.status_msg, false)
    //             }
    //           })
    //           .catch((err) => {
    //             this.showMsgDialog('error', err, false)
    //             this.loading = false
    //           })
    //       }
    //     }
    //   )
    // },
    cancelReportDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin cancel dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            note: res.value
          }
          axios
            .post(`${this.dssApi}initialreport/cancel`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    setDraftReport() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin SET DRAFT dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}initialreport/set_to_draft`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },

    deletePersonInvolve(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .delete(
              `${this.dssApi}initialreport/personinvolve/delete/${pItem.id}`
            )
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    personInvovleRowClick(pItem) {
      var objGender = null
      var objPersonType = null
      var objEngagementType = null
      var objEmployeeLeader = null
      var objCompany = null
      var objDepartment = null
      if (pItem.gender != null) {
        if (pItem.gender == 1) {
          objGender = {
            id: pItem.gender,
            name: 'Laki-laki'
          }
        }
        if (pItem.gender == 2) {
          objGender = {
            id: pItem.gender,
            name: 'Perempuan'
          }
        }
      }
      if (pItem.person_type != null) {
        if (pItem.person_type == 1) {
          objPersonType = {
            id: pItem.person_type,
            name: 'Karyawan'
          }
        }
        if (pItem.person_type == 2) {
          objPersonType = {
            id: pItem.person_type,
            name: 'Non Karyawan'
          }
        }
      }
      if (pItem.engagement_type != null) {
        if (pItem.engagement_type == 1) {
          objEngagementType = {
            id: pItem.engagement_type,
            name: 'Korban'
          }
        }
        if (pItem.engagement_type == 2) {
          objEngagementType = {
            id: pItem.engagement_type,
            name: 'Saksi'
          }
        }
      }
      if (pItem.employee_leader_id != null) {
        objEmployeeLeader = {
          id: pItem.employee_leader_id,
          name: pItem.employee_leader_name
        }
      }
      if (pItem.company_id != null) {
        objCompany = {
          id: pItem.company_id,
          name: pItem.company_name
        }
      }
      if (pItem.department_id != null) {
        objDepartment = {
          id: pItem.department_id,
          name: pItem.department_name
        }
      }

      this.personInvolveUpdateForm = {
        act: 'update',
        id: pItem.id,
        // initialreport_id: pItem.initialreport_id,
        name: pItem.name,
        birth_date: pItem.birth_date,
        gender: objGender,
        no_identitas: pItem.no_identitas,
        person_type: objPersonType,
        engagement_type: objEngagementType,
        employee_leader: objEmployeeLeader,
        injured_category: pItem.injured_category,
        injured_body_part_id: pItem.injured_body_part_id,
        machine_used: pItem.machine_used,
        amount_loss: pItem.amount_loss,
        rehabilitation_days: pItem.rehabilitation_days,
        company: objCompany,
        department: objDepartment
      }
      console.log('personInvovleRowClick', this.personInvolveUpdateForm)
      setTimeout(() => {
        document.getElementById('personInvolveForm').click()
      }, 200)
    },
    addNewPersonInvolve() {
      setTimeout(() => {
        document.getElementById('personInvolveForm').click()
      }, 200)
    },
    handlePersonFromChild(data) {
      // console.log('handlePersonFromChild.savePersonInvolve', data);
      this.personInvolveUpdateForm = data
      setTimeout(() => {
        document.getElementById('personInvolveForm').click()
      }, 200)
    },
    savePersonInvolve(data) {
      console.log('incidentreport.savePersonInvolve', data)
      if (data != null) {
        const form = {
          name: data.name,
          birth_date: data.birth_date,
          gender: data.gender != null ? data.gender.id : null,
          no_identitas: data.no_identitas,
          person_type: data.person_type != null ? data.person_type.id : null,
          engagement_type:
            data.engagement_type != null ? data.engagement_type.id : null
        }
        if (data.engagement_type.id === 1) {
          Object.assign(form, {
            injured_category_id:
              data.injured_category != null ? data.injured_category.id : null,
            injured_body_part_id: data.injured_body_part_id,
            machine_used: data.machine_used,
            amount_loss: data.amount_loss,
            rehabilitation_days: data.rehabilitation_days
          })

          if (data.employee_leader != null) {
            Object.assign(form, {
              employee_leader_id: data.employee_leader.id,
              employee_leader_name: data.employee_leader.name
            })
          }

          if (data.person_type.id == 1) {
            Object.assign(form, {
              company_id: data.company.id,
              company_name: data.company.name,
              department_id: data.department.id,
              department_name: data.department.name
            })
          }
        }
        if (data.act == 'add') {
          Object.assign(form, {
            act: data.act,
            initialreport_id: this.detailData.id
          })
        }
        if (data.act == 'update') {
          Object.assign(form, {
            act: data.act,
            id: data.id
          })
        }
        this.submitPersonInvolve(form)
      } else {
        this.personInvolveUpdateForm = null
      }
    },
    async submitPersonInvolve(form) {
      this.loading = true
      console.log(form)
      await axios
        .post(`${this.dssApi}initialreport/personinvolve/save`, form)
        .then(async (res) => {
          console.log(res.data)
          this.loading = false
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.personInvolveUpdateForm = null
            this.getDataFromApi()
            if (
              this.detailData != null &&
              this.detailData.inspection_report != null
            ) {
              this.$refs.inspectionReportRef.getDataFromApi()
            }
            // this.$nextTick(() => {
            //   this.$refs.personInvolveRef.closePersonInvolveDialog();
            // });
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async getInspectionReportDetail() {
      if (
        this.detailData != null &&
        this.detailData.inspection_report != null
      ) {
        return this.$refs.inspectionReportRef.getDataFromApi()
      } else {
        this.showMsgDialog(
          'question',
          'Laporan pemeriksaan dan pengkajian masalah belum tersedia, apakah anda ingin membuat dokumen baru ?',
          true,
          'Buat Dokumen',
          'Batalkan'
        ).then(async (res) => {
          if (res.isConfirmed) {
            this.createInspectionDocument()
          }
        })
      }

      setTimeout(() => {
        this.stepper_value = 1
      }, 0)
    },
    async getRootProblemReportDetail() {
      if (
        this.detailData != null &&
        this.detailData.inspection_report != null
      ) {
        if (
          this.detailData.inspection_report.status != 1 &&
          this.detailData.root_problem_report == null
        ) {
          this.showMsgDialog(
            'warning',
            'Laporan pemeriksaan dan pengkajian masalah belum disubmit, harap submit laporan terlebih dahulu',
            false
          )
        } else {
          if (
            this.detailData != null &&
            this.detailData.root_problem_report != null
          ) {
            return this.$refs.rootProblemReportRef.getDataFromApi()
          } else {
            this.showMsgDialog(
              'question',
              'Laporan pencarian akar masalah belum tersedia, apakah anda ingin membuat dokumen ?',
              true,
              'Buat Dokumen',
              'Batalkan'
            ).then(async (res) => {
              if (res.isConfirmed) {
                this.createRootProblemDocument()
              }
            })
          }
        }
      } else {
        this.showMsgDialog(
          'warning',
          'Harap but laporan pemeriksaan dan pengkajian masalah dahulu',
          false
        )
      }

      setTimeout(() => {
        this.stepper_value = 1
      })
    },
    async createInspectionDocument() {
      this.isLoadingPage = true

      const form = {
        act: 'add',
        initialreport_id: this.detailData.id
      }

      console.log(form)
      await axios
        .post(`${this.dssApi}inspectionreport/save`, form)
        .then(async (res) => {
          this.isLoadingPage = false
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.isLoadingPage = false
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async createRootProblemDocument() {
      this.isLoadingPage = true

      const form = {
        act: 'add',
        initialreport_id: this.detailData.id
      }

      console.log(form)
      await axios
        .post(`${this.dssApi}rootproblemreport/save`, form)
        .then(async (res) => {
          this.isLoadingPage = false
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.getDataFromApi()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.isLoadingPage = false
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    initialStatusName(val) {
      const arrType = ['DRAFT', 'SUBMITTED', 'CANCEL']
      return arrType[val]
    },
    initialStatusColor(val) {
      let arrType = ''
      if (val != null) {
        arrType = ['grey', 'green', 'red']

        return arrType[val.id]
      } else {
        return arrType
      }
    },
    validateInspectionRules() {
      if (
        this.detailData == null ||
        this.detailData.inspection_report == null
      ) {
        return false
      } else {
        if (this.detailData.inspection_report.status != 1) {
          return false
        }
      }
      return true
    },
    validateRootProblemRules() {
      if (
        this.detailData == null ||
        this.detailData.root_problem_report == null
      ) {
        return false
      } else {
        if (this.detailData.root_problem_report.status != 5) {
          return false
        }
      }
      return true
    },
    calculateAge(birthDate) {
      const today = new Date()
      const birthDateObj = new Date(birthDate)
      let age = today.getFullYear() - birthDateObj.getFullYear()
      const monthDifference = today.getMonth() - birthDateObj.getMonth()

      // If the birthday hasn't occurred yet this year, subtract 1 from age
      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDateObj.getDate())
      ) {
        age--
      }

      return age
    },
    getBodyPartName(obj) {
      const xFindBodyPart = this.dropdown.body_part.find((d) => d.id == obj)
      let xBodyPartName = '-'
      if (xFindBodyPart != undefined) {
        xBodyPartName = xFindBodyPart.name
      }

      return xBodyPartName
    },
    countVictims(data) {
      let lakiLaki = 0
      let perempuan = 0
      let meninggalDunia = 0
      let lukaBerat = 0
      let lukaRingan = 0

      // Iterasi setiap objek dalam data
      data.forEach((victim) => {
        // Menghitung jumlah laki-laki dan perempuan
        console.log(victim)
        if (victim.engagement_type == 1) {
          if (victim.gender != null) {
            if (victim.gender == 1) {
              lakiLaki++
            } else if (victim.gender == 2) {
              perempuan++
            }
          }
          if (victim.injured_category != null) {
            // Menghitung kategori luka
            if (victim.injured_category.name === 'Meninggal Dunia') {
              meninggalDunia++
            } else if (victim.injured_category.name == 'Luka Berat') {
              lukaBerat++
            } else if (victim.injured_category.name == 'Luka Ringan') {
              lukaRingan++
            }
          }
        }
      })

      // Menampilkan hasil
      return {
        lakiLaki,
        perempuan,
        meninggalDunia,
        lukaBerat,
        lukaRingan
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-scroll-wrapper {
  max-height: 73vh; /* Or whatever fits your layout */
  overflow-y: auto;
  position: relative;
  padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    // display: none;
    width: 4px;
    background: aquamarine;
  }
  &::-webkit-scrollbar-thumb {
    background: cornflowerblue;
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 6;
}

// .step-content {
// padding: 10px;
// }
</style>
